import { environment } from '../../../environments/environment';

function isMobileSafari(): boolean {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent) && /Safari/i.test(navigator.userAgent) && !/CriOS/i.test(navigator.userAgent);
}

function openLink(link): void {
  setTimeout((): void => {
    if (environment.openFileInNewTab) {
      const target: string = isMobileSafari() ? '_self' : '_blank';
      window.open(link, target);
    }
  }, 300);
}

function downloadLink(link: string, filename?: string): void {
  const a: HTMLAnchorElement = document.createElement('a');
  a.href = link;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.download = filename || '';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export { openLink, downloadLink };
